var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29237_26401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 4C13 3.73478 12.8946 3.48043 12.7071 3.29289C12.5196 3.10536 12.2652 3 12 3C11.7348 3 11.4804 3.10536 11.2929 3.29289C11.1054 3.48043 11 3.73478 11 4V5H9.5C8.43913 5 7.42172 5.42143 6.67157 6.17157C5.92143 6.92172 5.5 7.93913 5.5 9C5.5 10.0609 5.92143 11.0783 6.67157 11.8284C7.42172 12.5786 8.43913 13 9.5 13H14.5C15.0304 13 15.5391 13.2107 15.9142 13.5858C16.2893 13.9609 16.5 14.4696 16.5 15C16.5 15.5304 16.2893 16.0391 15.9142 16.4142C15.5391 16.7893 15.0304 17 14.5 17H7C6.73478 17 6.48043 17.1054 6.29289 17.2929C6.10536 17.4804 6 17.7348 6 18C6 18.2652 6.10536 18.5196 6.29289 18.7071C6.48043 18.8946 6.73478 19 7 19H11V20C11 20.2652 11.1054 20.5196 11.2929 20.7071C11.4804 20.8946 11.7348 21 12 21C12.2652 21 12.5196 20.8946 12.7071 20.7071C12.8946 20.5196 13 20.2652 13 20V19H14.5C15.5609 19 16.5783 18.5786 17.3284 17.8284C18.0786 17.0783 18.5 16.0609 18.5 15C18.5 13.9391 18.0786 12.9217 17.3284 12.1716C16.5783 11.4214 15.5609 11 14.5 11H9.5C8.96957 11 8.46086 10.7893 8.08579 10.4142C7.71071 10.0391 7.5 9.53043 7.5 9C7.5 8.46957 7.71071 7.96086 8.08579 7.58579C8.46086 7.21071 8.96957 7 9.5 7H17C17.2652 7 17.5196 6.89464 17.7071 6.70711C17.8946 6.51957 18 6.26522 18 6C18 5.73478 17.8946 5.48043 17.7071 5.29289C17.5196 5.10536 17.2652 5 17 5H13V4Z",
    fill: "#FF8C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29237_26401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerate);
export default __webpack_public_path__ + "static/media/generate.cfca7ee2ad3f5450bc8468b4dcee40e1.svg";
export { ForwardRef as ReactComponent };